import type { SnackbarContextType } from "@/contexts/snackbar/types";

export const defaultSnackbarContext: SnackbarContextType = {
  addSnackbar: () => {},
};

export const DELAY_BETWEEN_SNACKBARS_MS = 300;
